import Immutable from "immutable";
import { COLLECTION_SHAPE } from "../../../config/shapes";
import {
  CLEAR_MOVEMENT_REASONS, FLAG_BOARDING_DRAFT_ACTIVITY, GET_MOVEMENT_REASONS, LOAD_MOVEMENT_REASONS
} from "../../../actions/types";

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    activity: Immutable.List(),
  }),
  movementReasons: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  })
});

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case FLAG_BOARDING_DRAFT_ACTIVITY:
      if (payload) {
        return state.setIn(
          ["current", "activity"],
          state.getIn(["current", "activity"]).push(payload)
        );
      }
      return state.setIn(
        ["current", "activity"],
        state.getIn(["current", "activity"]).pop()
      );
    case LOAD_MOVEMENT_REASONS:
      return state.setIn(["movementReasons", "loading"], payload);
    case GET_MOVEMENT_REASONS:
      return state.setIn(
        ["movementReasons", "content"],
        Immutable.Map(payload)
      );
    case CLEAR_MOVEMENT_REASONS:
      return state.setIn(
        ["movementReasons", "content"],
        Immutable.Map(COLLECTION_SHAPE)
      );
    default:
      return state;
  }
}